export default "__VITE_ASSET__DMK1oo_z__"